'use client';

import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/routing';
import { useFirstAccessibleRoute } from '@/hooks/use-nav';
import { QrReviewListing } from './qr-review-listing';

export function QrReviewPage() {
  const t = useTranslations('qrReview');
  const tNav = useTranslations('navigation');
  const home = useFirstAccessibleRoute();

  return (
    <div className='space-y-6 p-6'>
      {/* Breadcrumb */}
      <nav className='text-muted-foreground flex items-center gap-2 text-sm'>
        <Link href={home} className='hover:text-foreground transition-colors'>
          {tNav('breadcrumb.dashboard')}
        </Link>
        <span>·</span>
        <span className='text-foreground font-medium'>
          {tNav('breadcrumb.qrReview')}
        </span>
      </nav>

      {/* Page header */}
      <div className='flex items-start justify-between'>
        <div>
          <h1 className='text-2xl font-bold tracking-tight'>
            {t('pageTitle')}
          </h1>
          <p className='text-muted-foreground text-sm'>{t('pageSubtitle')}</p>
        </div>
      </div>

      {/* Listing */}
      <QrReviewListing />
    </div>
  );
}
